import { render, staticRenderFns } from "./ViewShowList.vue?vue&type=template&id=46f1b15a&"
import script from "./ViewShowList.vue?vue&type=script&lang=js&"
export * from "./ViewShowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports